import { isUTelLogHandler } from "../LoggingHelper";
import { EventType } from "../UTelLogHandler";
/**
 * Emit a Core Telemetry event with only the default UTel fields.
 * @param logHandler Log handler used to emit the event
 */ export function Log(logHandler) {
    if (isUTelLogHandler(logHandler)) {
        logHandler.log({
            type: EventType.CoreTelemetry
        });
    }
}
